import React from 'react';
import { config } from '../../config/jewelleryLandingConfig';
import LocationSEO from '../sections/LocationSEO';

const scrollToContact = () => {
  const contactSection = document.getElementById('contact');
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const Footer = () => {
  return (
    <footer className="bg-espressoDeep text-soft border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-4 gap-12 py-20">
        {/* Column 1: BPA Solutions description */}
        <div className="col-span-1 md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-gold to-goldDark flex items-center justify-center">
              <span className="text-espressoDeep font-serif text-lg leading-none pt-0.5">B</span>
            </div>
            <h3 className="text-xl font-serif text-paper">{config.brand.name}</h3>
          </div>
          <p className="text-soft/60 max-w-sm mb-8 font-light leading-relaxed text-sm">
            Done-for-you ecommerce imagery and try-on style videos for jewellery brands that want sharper product pages, stronger ads and a more premium buying experience.
          </p>
          <div className="flex flex-col gap-2">
            <button 
              onClick={scrollToContact}
              className="inline-block text-gold text-xs tracking-widest uppercase hover:text-champagne transition-colors duration-300 w-fit font-bold"
            >
              Request a Visual Sample →
            </button>
          </div>
        </div>

        {/* Column 2: Contact */}
        <div>
          <h4 className="text-[10px] tracking-widest uppercase text-gold mb-6 font-bold">Contact</h4>
          <ul className="space-y-4 text-sm font-light text-soft/60">
            <li><a href={`mailto:${config.brand.email}`} className="hover:text-gold transition-colors">{config.brand.email}</a></li>
            <li><a href={`tel:${config.brand.phone.replace(/\s/g, '')}`} className="hover:text-gold transition-colors">{config.brand.phone}</a></li>
            <li>{config.brand.location}</li>
            <li><a href={config.brand.websiteUrl} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">{config.brand.websiteLabel}</a></li>
          </ul>
        </div>

        {/* Column 3: Legal */}
        <div>
          <h4 className="text-[10px] tracking-widest uppercase text-gold mb-6 font-bold">Legal</h4>
          <ul className="space-y-4 text-sm font-light text-soft/60">
            <li><a href="#" className="hover:text-gold transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-gold transition-colors">Terms of Service</a></li>
          </ul>
        </div>
      </div>

      {/* LocationSEO section - placed under contact details and above copyright */}
      <LocationSEO />

      {/* Copyright */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-8 pb-12 border-t border-white/5 text-center text-xs font-light text-soft/40">
        &copy;{new Date().getFullYear()} {config.brand.name}. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;